import { Component, ElementRef, OnInit, ViewChild,Input } from '@angular/core';
import html2canvas from 'html2canvas';
import jspdf  from 'jspdf';  
import { LanguageService } from '../../services/language.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-invoice-paper-bill',
  templateUrl: './invoice-paper-bill.component.html',
  styleUrls: ['./invoice-paper-bill.component.scss']
})
export class InvoicePaperBillComponent implements OnInit {

  @Input() data:any;
  @Input() username:any;
  isLoading:boolean = false
  barValue= ""
  constructor(
    public languageService:LanguageService,
    public modalService:NgbModal,
  ) { }

  ngOnInit(): void {
    console.log(this.data)
    this.barValue = this.data.BillRef
  }
  @ViewChild('content') content: ElementRef|any

  
  public SavePDF(): void { 
    this.isLoading =true 
    // let content=this.content.nativeElement;  
    // let doc = new jspdf('p', 'pt', 'a4');  
    // doc.addFont('Amiri', 'Amiri-Regular', 'normal');
    // doc.setFont('Amiri');
    // doc.html(content.innerHTML,{
    //   callback: (pdf) =>{
    //     doc.save('test.pdf'); 
    //   }
    // });  

    let DATA: any = document.getElementById('htmlData');
    html2canvas(DATA,).then((canvas) => {
     
      let fileWidth = 140;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jspdf('p', 'mm', 'a4');
      let yposition = 0;
      let xposition = 40;
      PDF.addImage(FILEURI, 'PNG', xposition, yposition, fileWidth, fileHeight);
      PDF.save('bill-invoice.pdf');
    });
    setTimeout(() => {
      this.isLoading =false 
    }, 1000);
  }  

}
